(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tire-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTireFinder(root) {
      if (!root || root.dataset.tfReady) return;
      root.dataset.tfReady = 'true';

      var tabs = root.querySelectorAll('[data-tf-bike]');
      var pills = root.querySelectorAll('[data-tf-style]');
      var cards = root.querySelectorAll('[data-tf-card]');
      var tubes = root.querySelectorAll('[data-tf-tube]');
      var count = root.querySelector('[data-tf-count]');
      var empty = root.querySelector('[data-tf-empty]');
      var tubeWrap = root.querySelector('[data-tf-tubes]');
      if (!tabs.length) return;

      var bike = tabs[0].dataset.tfBike;
      var bikeLabel = tabs[0].dataset.label;
      var style = 'all';

      function fits(el) {
        return (' ' + el.dataset.bikes + ' ').indexOf(' ' + bike + ' ') > -1;
      }

      function render() {
        var counts = {};
        var total = 0;
        cards.forEach(function (card) {
          if (!fits(card)) return;
          total++;
          counts[card.dataset.style] = (counts[card.dataset.style] || 0) + 1;
        });

        var present = Object.keys(counts);
        if (style !== 'all' && !counts[style]) style = 'all';
        if (present.length === 1) style = present[0];

        pills.forEach(function (pill) {
          var key = pill.dataset.tfStyle;
          var n = key === 'all' ? total : counts[key] || 0;
          pill.hidden = key === 'all' ? present.length < 2 : n === 0;
          pill.querySelector('[data-tf-n]').textContent = n;
          pill.setAttribute('aria-pressed', key === style ? 'true' : 'false');
        });

        var shown = 0;
        cards.forEach(function (card) {
          var on = fits(card) && (style === 'all' || card.dataset.style === style);
          card.hidden = !on;
          if (on) shown++;
        });

        count.textContent = shown + (shown === 1 ? ' tire fits ' : ' tires fit ') + bikeLabel;
        empty.hidden = shown > 0;

        var tubeCount = 0;
        tubes.forEach(function (tube) {
          var on = fits(tube);
          tube.hidden = !on;
          if (on) tubeCount++;
        });
        tubeWrap.hidden = tubeCount === 0;

        tabs.forEach(function (tab) {
          tab.setAttribute('aria-pressed', tab.dataset.tfBike === bike ? 'true' : 'false');
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          bike = tab.dataset.tfBike;
          bikeLabel = tab.dataset.label;
          style = 'all';
          render();
        });
      });

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          style = pill.dataset.tfStyle;
          render();
        });
      });

      render();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tire-finder]').forEach(initTireFinder);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
